export const featureProperties = {
  NO_OF_FORMS: 'NO_OF_FORMS',
  NO_OF_SUBMISSIONS: 'NO_OF_SUBMISSIONS',
  HAS_ANSWERBASED: 'HAS_ANSWERBASED',
  HAS_VISITORBASED: 'HAS_VISITORBASED',
  HAS_SCOREBASED: 'HAS_SCOREBASED',
  FILE_UPLOAD_STORAGE: 'FILE_UPLOAD_STORAGE',
  FILE_SIZE_LIMIT: 'FILE_SIZE_LIMIT',
  NO_OF_LANDING_PAGES: 'NO_OF_LANDING_PAGES',
  NO_OF_AI_GENERATED_LANDING_PAGES: 'NO_OF_AI_GENERATED_LANDING_PAGES',
  ENABLE_TRUSTEDFORM: 'ENABLE_TRUSTEDFORM',
  ENABLE_SIGNATURE: 'ENABLE_SIGNATURE',
  HAS_BRANDING: 'HAS_BRANDING',
  NO_OF_DOCUMENTS: 'NO_OF_DOCUMENTS',
  HAS_API_ACCESS: 'HAS_API_ACCESS',
  HAS_WEBHOOKS: 'HAS_WEBHOOKS',
  NO_OF_TEAM_MEMBERS: 'NO_OF_TEAM_MEMBERS',
  NO_OF_TEAMS: 'NO_OF_TEAMS',
  ESIGN_STORAGE_MB: 'ESIGN_STORAGE_MB',
  MAX_DOCUMENT_FILE_SIZE_MB: 'MAX_DOCUMENT_FILE_SIZE_MB',
  ENABLE_PAYMENT: 'ENABLE_PAYMENT'
}
